class FaqSection extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const acc = this.querySelectorAll('.faq-section__title');
    acc.forEach((btn) => {
      btn.addEventListener('click', function () {
        this.classList.toggle('active');
        const panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }
}

if (!customElements.get('faq-section')) {
  customElements.define('faq-section', FaqSection);
}
